export default __webpack_public_path__ + "images/3ec01545a71de4f4398c24072fa8a2fa-halloween_seasonal_mobile.webp";